import React, { forwardRef, useId } from "react";

/**
 * Радіокнопка в тому ж стилі, що й `AppCheckbox`: прихований нативний input + малювання на `label`
 * (див. `.form-check.app-radio` у `_variables.scss`).
 */
export const AppRadio = forwardRef(function AppRadio(
    { id: idProp, name, label, value, checked, onChange, disabled, className, style, title, ...rest },
    ref
) {
    const autoId = useId();
    const inputId = idProp != null && String(idProp).length > 0 ? idProp : autoId;

    return (
        <div
            className={className ? `form-check app-radio ${className}`.trim() : "form-check app-radio"}
            style={style}
            title={title}
        >
            <input
                {...rest}
                ref={ref}
                type="radio"
                id={inputId}
                name={name}
                value={value}
                className="form-check-input"
                checked={checked}
                onChange={onChange}
                disabled={disabled}
            />
            <label className="form-check-label" htmlFor={inputId}>
                {label}
            </label>
        </div>
    );
});

AppRadio.displayName = "AppRadio";
